// ── Canonical es-ES labels for prompt template {{variables}} ──
// Single source of truth shared by AIPrompts.tsx (editor chips + slash menu) and
// the Autom Cadence PromptDrawer (read-only prompt preview). Any {{var}} rendered
// in either surface reads its Spanish label from here; keeping one map avoids the
// drift that left 'country' unlabelled in the drawer while the 9-day prompts use it.

// Ordered variable definitions with an example value. AIPrompts uses the full list
// (label + example) for its variable chips and slash-command menu; the drawer only
// needs the label lookup (VARIABLE_LABELS below), which is derived from this list.
export const TEMPLATE_VARIABLES = [
  { key: 'first_name', label: 'Nombre', example: 'Juan' },
  { key: 'last_name', label: 'Apellido', example: 'Perez' },
  { key: 'company', label: 'Empresa', example: 'Walmart' },
  { key: 'title', label: 'Cargo', example: 'VP Engineering' },
  { key: 'country', label: 'País', example: 'México' },
  { key: 'email', label: 'Email', example: 'juan@empresa.com' },
  { key: 'linkedin_url', label: 'LinkedIn', example: 'linkedin.com/in/...' },
  { key: 'industry', label: 'Industria', example: 'e-learning' },
  { key: 'website', label: 'Sitio Web', example: 'edpuzzle.com' },
  { key: 'department', label: 'Departamento', example: 'Sales' },
  { key: 'annual_revenue', label: 'Ingresos Anuales', example: '$10M' },
  { key: 'research', label: 'Investigación de empresa', example: 'Reporte AI de la empresa' },
] as const

// key → es-ES label. Derived from TEMPLATE_VARIABLES so the two never diverge.
// A {{var}} absent from this map falls back to its raw key at the call site.
export const VARIABLE_LABELS: Record<string, string> = Object.fromEntries(
  TEMPLATE_VARIABLES.map((v) => [v.key, v.label]),
)
